import { render, staticRenderFns } from "./AddDepositWithdrawalPanel.vue?vue&type=template&id=51afd39c&scoped=true&"
import script from "./AddDepositWithdrawalPanel.vue?vue&type=script&lang=js&"
export * from "./AddDepositWithdrawalPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddDepositWithdrawalPanel.vue?vue&type=style&index=0&id=51afd39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afd39c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51afd39c')) {
      api.createRecord('51afd39c', component.options)
    } else {
      api.reload('51afd39c', component.options)
    }
    module.hot.accept("./AddDepositWithdrawalPanel.vue?vue&type=template&id=51afd39c&scoped=true&", function () {
      api.rerender('51afd39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/AddDepositWithdrawalPanel.vue"
export default component.exports